import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages, injectIntl, intlShape } from 'react-intl';

import FieldInput from 'brastrap/common/field-input/FieldInput';
import FieldSelect from 'brastrap/common/field-select/FieldSelect';
import FieldSet from 'brastrap/common/fieldset/Fieldset';

// TODO: These values need localised, but furthermore the entries in the list need localised for different markets.
export const titleOptions = [
  { label: 'Ms', value: 'Ms' },
  { label: 'Mrs', value: 'Mrs' },
  { label: 'Miss', value: 'Miss' },
  { label: 'Mr', value: 'Mr' },
  { label: 'Mx', value: 'Mx' },
  { label: 'Dr', value: 'Dr' },
  { label: 'Prof', value: 'Prof' },
  { label: 'Sgt', value: 'Sgt' },
  { label: 'Sir', value: 'Sir' },
  { label: 'Capt', value: 'Capt' },
  { label: 'Major', value: 'Major' },
  { label: 'Lady', value: 'Lady' },
  { label: 'Lord', value: 'Lord' },
  { label: 'Revd', value: 'Revd' },
  { label: 'Cpl', value: 'Cpl' },
  { label: 'Ind', value: 'Ind' },
  { label: 'Mre', value: 'Mre' },
  { label: 'Msr', value: 'Msr' },
  { label: 'Pr', value: 'Pr' },
  { label: 'Misc', value: 'Misc' },
];

const messages = defineMessages({
  email: { id: 'personal-details-field-set.email', defaultMessage: 'Email' },
  firstName: {
    id: 'personal-details-field-set.first-name',
    defaultMessage: 'First name',
  },
  formNote: {
    id: 'personal-details-field-set.form-note',
    defaultMessage: '*Required field',
  },
  lastName: {
    id: 'personal-details-field-set.last-name',
    defaultMessage: 'Last name',
  },
  phoneDaytime: {
    id: 'personal-details-field-set.contact-number',
    defaultMessage: 'Contact number',
  },
  phoneMobile: {
    id: 'personal-details-field-set.mobile-number',
    defaultMessage: 'Additional contact number',
  },
  title: { id: 'personal-details-field-set.title', defaultMessage: 'Title' },
  topTitle: {
    id: 'personal-details-field-set.top-title',
    defaultMessage: 'Personal Details',
  },
});

const PersonalDetailsFieldSet = props => {
  const {
    intl: { formatMessage },
    title,
    firstName,
    lastName,
    email,
    phoneDaytime,
    phoneMobile,
    displayEmailFirst,
  } = props;

  return (
    <FieldSet
      title={formatMessage(messages.topTitle)}
      note={formatMessage(messages.formNote)}
    >
      {displayEmailFirst && (
        <FieldInput
          {...email}
          label={formatMessage(messages.email)}
          modifiers={['large']}
          floatLabel
          required
          id="email"
          type="email"
          note={email.error}
        />
      )}

      <FieldSelect
        {...title}
        label={formatMessage(messages.title)}
        placeholder={formatMessage(messages.title)}
        hiddenLabel
        options={titleOptions}
        modifiers={['large', 'inline']}
        id="title"
        note={title.error}
      />

      <FieldInput
        {...firstName}
        label={formatMessage(messages.firstName)}
        modifiers={['large', 'inline']}
        floatLabel
        required
        id="firstName"
        note={firstName.error}
      />

      <FieldInput
        {...lastName}
        label={formatMessage(messages.lastName)}
        modifiers={['large', 'inline']}
        floatLabel
        required
        id="lastName"
        note={lastName.error}
      />

      {!displayEmailFirst && (
        <FieldInput
          {...email}
          label={formatMessage(messages.email)}
          modifiers={['large']}
          floatLabel
          required
          id="email"
          type="email"
          note={email.error}
        />
      )}

      <FieldInput
        {...phoneDaytime}
        label={formatMessage(messages.phoneDaytime)}
        modifiers={phoneMobile ? ['large', 'inline'] : ['large']}
        floatLabel
        type="tel"
        id="phoneDaytime"
        note={phoneDaytime.error}
        required
      />

      {phoneMobile && (
        <FieldInput
          {...phoneMobile}
          label={formatMessage(messages.phoneMobile)}
          modifiers={['large', 'inline']}
          floatLabel
          type="tel"
          id="phoneMobile"
          note={phoneMobile.error}
        />
      )}
    </FieldSet>
  );
};

//
// The field properties are all objects, because they will be redux-form field objects, rather than string.
//
PersonalDetailsFieldSet.propTypes = {
  title: PropTypes.object,
  firstName: PropTypes.object,
  lastName: PropTypes.object,
  email: PropTypes.object,
  phoneDaytime: PropTypes.object,
  phoneMobile: PropTypes.object,
  intl: intlShape,
  displayEmailFirst: PropTypes.bool,
};

PersonalDetailsFieldSet.defaultProps = {
  displayEmailFirst: false,
  email: {},
  firstName: {},
  lastName: {},
  phoneDaytime: {},
  title: {},
};

export default injectIntl(PersonalDetailsFieldSet);
